import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Organization, User } from '@app/models';
import { InteractionServiceV2, UserService } from '@app/services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VersionService } from 'app/_services/version.service';
import { fadeInLeft } from '../../_helpers/animations/fade.animations';
import { MENU } from '../../_helpers/menu.helper';
import { OrganizationService } from '../../_services/organization.service';
import { SessionConfigService } from '../../_services/session-config.service';
import { ChangeNotesModalComponent } from '../change-notes-modal/change-notes-modal.component';

@Component({
  selector: 'app-evo-navigation-bar',
  templateUrl: './evo-navigation-bar.component.html',
  styleUrls: ['./evo-navigation-bar.component.scss'],
  animations: [fadeInLeft],
})
export class EvoNavigationBarComponent implements OnInit {
  @Input() currentUser: User;
  @Input() currentOrganization: Organization;
  barIsCollapsed = false;
  barIsExpanding = false;
  activeNavId: string;
  navigationMenus: any[];

  public totalMonth: number;

  public showUpdateVersion = false;

  constructor(
    public userService: UserService,
    private router: Router,
    public organizationService: OrganizationService,
    public interactionService: InteractionServiceV2,
    public versionService: VersionService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.navigationMenus = MENU;
    this.barIsCollapsed = SessionConfigService.getSidebarStatus();

    this.versionService.getVersion().subscribe((data: any) => {
      if (data && data.version != this.versionService.config.version) {
        this.versionService.newVersionAvailable = true;
        this.versionService.newVersion = data.version;
      }
    });
  }

  public getInteractionMonth(): void {
    /*this.interactionService.getTotalMonth().subscribe(
			data => {
				this.totalMonth = data;
			}, error => {
				this.totalMonth = 0;
				console.error(error);
			}
		)*/
  }

  logout() {
    this.userService.logout();
    this.router.navigate(['/login']);
  }

  toggleNavbar(forceValue?: boolean) {
    const newCollapsedValue =
      forceValue !== undefined ? forceValue : !this.barIsCollapsed;

    // Create delay for a smooth animation
    if (this.barIsCollapsed && !newCollapsedValue) {
      this.barIsExpanding = true;
      setTimeout(() => {
        this.barIsExpanding = false;
      }, 100);
    }
    // Remove active status
    if (newCollapsedValue) {
      this.activeNavId = null;
    }

    this.barIsCollapsed = newCollapsedValue;
    SessionConfigService.setSidebarStatus(this.barIsCollapsed);
  }

  public updateVersion(): void {
    window.location.href =
      window.location.origin +
      window.location.pathname +
      '?v=' +
      new Date().getTime();
  }

  public openChangeNotesModal(): void {
    const modalRef = this.modalService.open(ChangeNotesModalComponent, {
      size: 'lg',
      centered: true,
      scrollable: true
    });
    modalRef.componentInstance.version = this.versionService.config?.version;
  }
}
